import {text_mod_24, } from "../text/Text.js";
export const module24 = {
  title:
    "§24. Перенос слів з апострофом.Перенос слів із подовженими приголосними звуками",
  questions: [
    {
      id: 1,
      onlyText: true,
      text: text_mod_24, },
    ]
  }
